import React, { type ReactElement } from 'react';

import { ProButton } from '@components/Button/variants';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

import { ClusterOfferingProps } from './interfaces';

const ClusterOffering = ({
  buttonText,
  description,
  link,
  headline,
}: ClusterOfferingProps): ReactElement => {
  const { trackEvent } = useEventTracking();

  const handleOfferingClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.ViewMore, clickText: buttonText }));
  };

  return (
    <article className="flex w-full flex-col sm:max-w-[400px]">
      <header>
        <h3 className="m-0 font-suisse-works text-headline-xxs sm:text-headline-xs">{headline}</h3>
      </header>
      <p className="mb-16 mt-8 text-pretty font-suisse-intl text-body-md font-normal sm:text-body-lg">
        {description}
      </p>
      <ProButton
        as="link"
        className="mt-auto max-w-[206px]"
        href={link}
        onClickCapture={handleOfferingClick}
        fullWidth={false}
      >
        {buttonText}
      </ProButton>
    </article>
  );
};

export default ClusterOffering;
